import { createFileRoute } from "@tanstack/react-router";
import { Identities } from "@/components/Identities";

function RouteComponent() {
  return <Identities />;
}

export const Route = createFileRoute("/_authenticated/identities/")({
  component: RouteComponent,
  staticData: { page: "identities" },
});
